<template>
  <div class="main-content">
    <div class="card p-2">
      <div class="mb-2 bread">
        WFR <span class="sep2">›</span>
        <span @click="$router.push('/Flow/form-templates')" class="bread-link"
          >Modelos de Formulário</span
        >
        <span class="sep2">›</span>
        {{ isEdit ? "Editar modelo" : "Novo modelo" }}
      </div>

      <div class="d-flex justify-content-between align-items-center mb-3">
        <h4 class="m-0 page-title">
          {{ isEdit ? "Editar modelo de formulário" : "Novo modelo de formulário" }}
        </h4>
      </div>

      <div class="section-card">
        <div class="section-title">Informações do modelo</div>

        <div class="row">
          <div class="col-md-12">
            <label class="lbl">Título <span class="req">*</span></label>
            <input
              v-model="form.title"
              class="form-control"
              placeholder="Ex: Checklist de aprovação financeira"
            />
          </div>
        </div>

        <div class="row mt-2">
          <div class="col-md-12">
            <label class="lbl">Descrição</label>
            <textarea
              v-model="form.description"
              class="form-control text-area"
              rows="3"
              placeholder="Descreva quando este formulário deve ser usado..."
            ></textarea>
          </div>
        </div>
      </div>

      <div class="section-card mt-3">
        <div class="section-title m-0">Perguntas</div>
        <div class="help-muted mb-2">
          Estas perguntas poderão ser reaproveitadas em qualquer etapa de
          qualquer solicitação de flow.
        </div>

        <question-builder v-model="form.questions" />

        <div v-if="error" class="alert alert-danger mt-2 p-2">{{ error }}</div>

        <div
          class="d-flex justify-content-end align-items-center mt-3"
          style="gap: 10px"
        >
          <button class="btn btn-outline-secondary" @click="cancel">
            Voltar
          </button>
          <button class="btn btn-primary" :disabled="saving" @click="save">
            {{
              saving
                ? "Salvando..."
                : isEdit
                ? "Salvar alterações"
                : "Criar modelo"
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionBuilder from "./QuestionBuilder.vue";

export default {
  components: { QuestionBuilder },

  data() {
    return {
      isEdit: false,
      saving: false,
      error: "",

      form: {
        title: "",
        description: "",
        questions: [],
      },
    };
  },

  async mounted() {
    if (this.$route.params.id) {
      this.isEdit = true;
      await this.loadTemplate(this.$route.params.id);
    }
  },

  methods: {
    async loadTemplate(id) {
      try {
        const apiBase = this.$store.state.api;
        const res = await this.$http.get(apiBase + "form-templates/" + id);
        const tpl = res.data;

        this.form.title = tpl.title || "";
        this.form.description = tpl.description || "";
        this.form.questions = (tpl.questions || [])
          .slice()
          .sort((a, b) => Number(a.order || 0) - Number(b.order || 0))
          .map((q) => ({
            label: q.label,
            field_type: q.field_type,
            options: q.options || [],
            required: !!q.required,
          }));
      } catch (e) {
        console.error(e);
        this.error = "Não consegui carregar o modelo.";
      }
    },

    validate() {
      this.error = "";
      if (!this.form.title.trim()) {
        this.error = "Informe o título do modelo.";
        return false;
      }
      if (!this.form.questions.length) {
        this.error = "Adicione ao menos uma pergunta.";
        return false;
      }
      return true;
    },

    async save() {
      if (!this.validate()) return;
      this.saving = true;
      this.error = "";
      try {
        const apiBase = this.$store.state.api;
        const payload = {
          title: this.form.title,
          description: this.form.description || null,
          questions: this.form.questions.map((q) => ({
            label: q.label,
            field_type: q.field_type,
            options: q.options || [],
            required: !!q.required,
          })),
        };

        if (this.isEdit) {
          await this.$http.put(
            apiBase + "form-templates/" + this.$route.params.id,
            payload
          );
        } else {
          await this.$http.post(apiBase + "form-templates", payload);
        }

        this.$router.push("/Flow/form-templates");
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data ||
          "Erro ao salvar o modelo.";
        this.error = typeof msg === "string" ? msg : JSON.stringify(msg);
      } finally {
        this.saving = false;
      }
    },

    cancel() {
      this.$router.push("/Flow/form-templates");
    },
  },
};
</script>

<style scoped>
.bread {
  font-size: 12px;
  color: #6b7280;
  font-weight: 700;
}
.sep2 {
  margin: 0 6px;
  color: #9ca3af;
}
.bread-link {
  cursor: pointer;
  color: #2563eb;
  text-decoration: underline;
}
.page-title {
  font-weight: 700;
  color: #111827;
}
.form-control {
  height: 38px;
}
.text-area {
  height: auto;
  min-height: 88px;
  resize: vertical;
  padding-top: 10px;
}
.section-card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 14px;
}
.section-title {
  font-size: 16px;
  font-weight: 800;
  color: #111827;
  margin-bottom: 12px;
}
.lbl {
  font-weight: 800;
  color: #374151;
  margin-bottom: 6px;
  display: block;
}
.req {
  color: #dc2626;
}
.help-muted {
  font-size: 12px;
  color: #6b7280;
  font-weight: 600;
}
</style>
